import { Stack, useLocalSearchParams } from 'expo-router';
import ModalStack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivatePersonPersonIdLayoutRoute() {
  const { personId } = useLocalSearchParams<{ personId: string }>();
  return (
    <ModalStack>
      <Stack.Screen
        name="edit/managers"
        initialParams={{ personId }}
        options={{
          title: 'Managers',
          headerBackTitle: '',
          headerBackButtonDisplayMode: 'minimal',
        }}
      />
    </ModalStack>
  );
}
